export default "/fonts/icon-font.svg?f0dcdeb62f280a632095d85841ae59bd";